module.exports = __webpack_public_path__ + "img/userStories.eb58862a.png";